import { ComparatorContext, usePage } from '@kizi/comparator-core';
import React, { useContext, useEffect } from 'react';
import { BasicInput } from './withFormProps';

export const BasicInputWrapper = ({ ...props }): JSX.Element => {
  const context = useContext(ComparatorContext);
  const comparatorName = context.name;
  const { state, setState } = usePage();

  const { name, value } = props;

  useEffect(() => {
    if (comparatorName === 'os-solar-panels') {
      if (state && setState) {
        setState({
          ...state,
          [name]: value,
        });
      }
    }
  }, [value]);

  return <BasicInput {...props} />;
};
